'use client'

import { Button } from '@/components/ui/button'
import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselPrevious,
} from '@/components/ui/carousel'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { ArrowRightIcon } from 'lucide-react'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import Link from 'next/link'

const IN_REAL_LIFE_IMAGES = [
  '/image/2026/03/06/Frame_88028.png',
  '/image/2026/03/06/Frame_88029.png',
  '/image/2026/03/06/Frame_88030.png',
]

export const JoinCommunitySection = () => {
  const t = useTranslations('community_threads')
  return (
    <section
      className='relative mt-10 flex w-full shrink-0 flex-col items-center overflow-clip bg-[#1a1a1a] bg-cover bg-center px-5 py-10 md:mt-20 md:px-16 md:py-14'
      style={{
        backgroundImage: `url(${ImageHelper.getN7ImageUrl('/image/2026/03/06/Frame_88046_1.jpg')})`,
      }}
    >
      <div className='relative flex w-full shrink-0 flex-col items-center gap-3 md:gap-8 md:py-10'>
        <div className='relative flex flex-col items-center gap-2 text-center'>
          <h2 className='font-criteria text-[26px] !font-medium uppercase italic tracking-[-1.1px] text-[#d9ff00] md:text-[55px]'>
            {t('join.title')}
          </h2>
          <p className='text-lg font-normal tracking-[-0.36px] text-white'>
            #Coolmate #Life #CM
          </p>
        </div>

        <div className='w-full'>
          <Carousel
            opts={{
              align: 'start',
              duration: 30,
              dragFree: true,
            }}
            className='w-full'
          >
            <CarouselContent className='-ml-4'>
              {IN_REAL_LIFE_IMAGES.map((imgSrc, idx) => (
                <CarouselItem
                  key={idx}
                  className='basis-[83.33%] cursor-default pl-4 md:basis-1/3'
                >
                  <div className='relative aspect-square w-full shrink-0 overflow-hidden rounded-[16px]'>
                    <Image
                      alt={`Coolmate In Real Life ${idx + 1}`}
                      className='pointer-events-none object-cover'
                      fill
                      src={ImageHelper.getN7ImageUrl(imgSrc)}
                    />
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            {IN_REAL_LIFE_IMAGES.length > 3 && (
              <>
                <CarouselPrevious
                  hideIfStart
                  variant='black'
                  className='absolute -left-4 top-1/2 h-10 w-10 -translate-y-1/2 lg:-left-12'
                />
                <CarouselNext
                  hideIfEnd
                  variant='black'
                  className='absolute -right-4 top-1/2 h-10 w-10 -translate-y-1/2 lg:-right-12'
                />
              </>
            )}
          </Carousel>
        </div>

        <Link href='https://coolmateme.sg.larksuite.com/share/base/form/shrlgp0FFHje3AOQBTQlZBhFQfe'>
          <Button variant='white' className='flex items-center gap-2'>
            {t('join.button')}
            <ArrowRightIcon className='size-5 text-black' />
          </Button>
        </Link>
      </div>
    </section>
  )
}
